// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui'
import store from './store'
import './assets/css/element-ui.css'
import Meta from 'vue-meta'
/* 引入aos动画库相关文件 */
import AOS from 'aos'
import 'aos/dist/aos.css'
// rem屏幕适配
import './utils/rem'
import VueResource from 'vue-resource'
import Footer1 from './components/footer/index.js'
import FooterMN from './components/mnFooter/index.js'
import BaiduMap from 'vue-baidu-map'
import './icons/index'

Vue.use(VueResource)
router.beforeEach((to, from, next) => {
  if (to.meta.metaInfo) {
    store.commit('app/CAHNGE_META_INFO', to.meta.metaInfo)
  }
  next()
})
// 使用vue-meta
Vue.use(Meta)
Vue.use(Footer1)
Vue.use(FooterMN)
Vue.use(BaiduMap, {
  ak: 'NbilbaSQmX0Gls16YGAKHju4GgW86REv'
})

const defaultSettings = require('./settings.js')
Vue.prototype.settings = defaultSettings // icon
/* aos动画初始化 */
AOS.init({
  duration: 1000,
  offset: 200,
  delay: 100,
  easing: 'ease-in-out-back'
})
Vue.use(Element)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  metaInfo () {
    return {

      title: this.$store.state.app.metaInfo.title,
      meta: [
        {
          name: 'keywords',
          content: this.$store.state.app.metaInfo.keywords
        }, {
          name: 'description',
          content: this.$store.state.app.metaInfo.description
        }
      ]
    }
  },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js